import { createFileRoute, redirect } from "@tanstack/react-router";

import { PairMachinePage } from "../components/environments/pairMachinePage";

export const Route = createFileRoute("/pair-machine")({
  beforeLoad: async ({ context }) => {
    if (context.authGateState.status !== "authenticated") {
      throw redirect({ to: "/login", replace: true });
    }
  },
  component: PairMachinePage,
});
